import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../game-services';
import { GameAssetType } from '../../game-types';

export class StartViewModel {
  public get buttonAsset() {
    return this.gameServices.assetCatalogueService.getAsset(GameAssetType.StartButton);
  }
  public get onShowStartButtonTrigger() {
    return this.showStartButtonTrigger.asObservable();
  }

  private readonly gameServices: GameServices;
  private readonly showStartButtonTrigger: BehaviorSubject<boolean>;

  constructor(gameServices: GameServices) {
    this.gameServices = gameServices;
    this.showStartButtonTrigger = new BehaviorSubject<boolean>(false);
  }

  public showStartButton(showButton: boolean) {
    this.showStartButtonTrigger.next(showButton);
  }

  public startClicked() {
    this.gameServices.gameRunnerService.startGame();
  }
}
